import StyleBase from '../../../styles/base';
const styles: any = {
  disclaimer: {
    color: '#323232',
    fontSize: 10,
    lineHeight: 14,
    marginTop: 20,
    textAlign: 'justify',
    [StyleBase.media.mobile]: {
      marginTop: 15,
    },
  },
  disclaimerContainer: {
    margin: '10px 0',
    padding: '0 8px',
  },
  compsDisclaimerText: {
    color: '#323232',
    fontSize: 10,
    marginTop: 10,
    textAlign: 'justify' as 'justify',
    [StyleBase.media.mobile]: {
      padding: '0 8px',
    },
  },

  mlsLogo: {
    height: 35,
    objectFit: 'contain',
  },

  listingsContent: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '8px',
    overflow: 'auto',
    border: 1,
  },

  infiniteScrollComponent: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'hidden',
    justifyContent: 'flex-start',
    [StyleBase.media.mobile]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
};

export default styles;
